import { useCallback,useRef } from "react"

const URL_ONBOARDING = process.env.REACT_APP_URL_ONBOARDING|| ''   

const encodeParams = (params: any) => {
    return btoa(JSON.stringify(params))
}

export type LoginOnboarding = {
  redirectToOnboarding: (leadUuid: string) => void;
}

export const useLoginOnboaring=():LoginOnboarding => {

    const refWindow = useRef<Window | null>(null)


    const redirectToOnboarding = useCallback((leadUuid: string) => {
        const session = JSON.parse(localStorage.getItem('session'))
        const agentUuid = session.uuid;
        const params = {
            leadUuid,
            agentUuid
        }
        const encodedParams = encodeParams(params);
        const url = `${URL_ONBOARDING}?p=${encodedParams}`
        if(refWindow.current && !refWindow.current.closed){
            refWindow.current.location.href=url
            refWindow.current.focus()
          return
        }
        refWindow.current=window.open(url, "_blank");
    }
    , [])

    return { redirectToOnboarding }
}